import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

import { LearningPathsSubpage } from './LearningPathsSubpage';
import { useLearningPathsData } from './useLearningPathsData';
import { SIDEBAR_ITEMS } from './useSidebarItems';

export const LearningPathsTopics = () => {
  const {
    groupedByCategoryLps,
    lpsWithDurationLeft,
    organizationName,
    isLoading,
  } = useLearningPathsData();

  const [searchParams] = useSearchParams();
  const selectedTopic = searchParams.get('topic');

  const learningPaths = useMemo(() => {
    if (!selectedTopic) return lpsWithDurationLeft;
    return groupedByCategoryLps[selectedTopic]?.lps ?? [];
  }, [selectedTopic, groupedByCategoryLps, lpsWithDurationLeft]);

  return (
    <LearningPathsSubpage
      title={selectedTopic ?? SIDEBAR_ITEMS.ALL_TOPICS}
      learningPaths={learningPaths}
      organizationName={organizationName}
      isLoading={isLoading}
    />
  );
};
